var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { attrs: { id: "header" } }, [
    _c("div", { attrs: { id: "not_found_div" } }, [
      _c("div", { staticClass: "inner_static" }, [
        _c("a", {
          attrs: { id: "btn_top" },
          on: {
            click: function($event) {
              _vm.btnTopClick()
            }
          }
        }),
        _vm._v(" "),
        _c(
          "h1",
          {
            staticClass: "kagull_logo_h1",
            style: _vm.logoStyle,
            attrs: { id: "h_logo" }
          },
          [_c("strong", [_vm._v("カグル.")])]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75b5f159", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b5f159","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/kagull/components/common/NotFoundHeader.vue
// module id = null
// module chunks = 